import React from "react";
import { Hash, MessageSquare, Loader2 } from "lucide-react";

// Presentational live-search results dropdown, shared by mobile + desktop
// Messages pages. `style` overrides colors to match each surface's theme.
export function ChatSearchDropdown({ results, loading, query, onSelect, style }) {
  const s = { bg: "#ffffff", border: "#e2e8f0", text: "#0f172a", sub: "#64748b", hoverBg: "#f8fafc", ...style };
  return (
    <div
      data-testid="chat-search-dropdown"
      className="absolute left-0 right-0 top-full mt-1.5 rounded-xl shadow-xl overflow-hidden z-50 max-h-[60vh] overflow-y-auto border"
      style={{ backgroundColor: s.bg, borderColor: s.border }}
    >
      {loading ? (
        <div className="px-4 py-5 flex items-center justify-center gap-2 text-[13px]" style={{ color: s.sub }} data-testid="chat-search-loading">
          <Loader2 className="h-4 w-4 animate-spin" /> Searching…
        </div>
      ) : results.length === 0 ? (
        <div className="px-4 py-5 text-center text-[13px]" style={{ color: s.sub }} data-testid="chat-search-empty">
          No matches for &ldquo;{query}&rdquo;
        </div>
      ) : (
        results.map((r) => {
          const Icon = r.conversationType === "dm" ? MessageSquare : Hash;
          return (
            <button
              key={`${r.conversationId}-${r.messageId || "chan"}`}
              onClick={() => onSelect(r)}
              data-testid={`chat-search-result-${r.conversationId}-${r.messageId || "chan"}`}
              className="w-full text-left px-3.5 py-2.5 flex items-start gap-2.5 border-b last:border-0 transition-colors"
              style={{ borderColor: s.border }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = s.hoverBg; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
            >
              <Icon className="h-3.5 w-3.5 mt-0.5 shrink-0" style={{ color: s.sub }} />
              <div className="min-w-0 flex-1">
                <div className="text-[13px] font-semibold truncate" style={{ color: s.text }}>{r.conversationName}</div>
                <div className="text-[12px] truncate" style={{ color: s.sub }}>
                  {r.senderName ? `${r.senderName}: ` : ""}{r.snippet}
                </div>
              </div>
            </button>
          );
        })
      )}
    </div>
  );
}
